import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE } from '../api-base.token';

export interface OrganizationMemberDto {
  id: string;
  organizationId: string;
  clientUserId: string;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  phoneNumber?: string;
  employeeId?: string;
  joinedAt: string;
  isActive: boolean;
  isOwner: boolean;
}

export interface PaginatedMembersResponse {
  items: OrganizationMemberDto[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
}

@Injectable({
  providedIn: 'root',
})
export class OrganizationMembersHttpService {
  constructor(
    private readonly http: HttpClient,
    @Inject(API_BASE) private readonly apiBase: string
  ) {}

  getAll(
    organizationId: string,
    pageSize = 100
  ): Observable<OrganizationMemberDto[]> {
    return new Observable((observer) => {
      this.http
        .get<PaginatedMembersResponse>(
          `${this.apiBase}/organizations/${organizationId}/members?pageSize=${pageSize}`
        )
        .subscribe({
          next: (response) => {
            observer.next(response.items);
            observer.complete();
          },
          error: (error) => observer.error(error),
        });
    });
  }

  getById(
    organizationId: string,
    memberId: string
  ): Observable<OrganizationMemberDto> {
    return this.http.get<OrganizationMemberDto>(
      `${this.apiBase}/organizations/${organizationId}/members/${memberId}`
    );
  }
}
